<template>
    <div class="wrapper--section section-columns" :style="`--bg: ${background}`">
    
        <div class="has-overflow">
            <header class="section-text__content">
                <h2 class="title title--dash" v-html="title" />
                <div class="section__text" v-if="text" v-html="text" />
            </header>

            <ul class="section__columns">
                <li
                    class="section__text-column"
                    v-for="item in items"
                    :key="item.text"
                    v-html="item.text"
                />
            </ul>
        </div>
        
    </div>
</template>

<script>
import { textProps, optionsProps } from './sectionProps'

export default {
    props: {
        items: [Array, Boolean],
        ...textProps,
        ...optionsProps,
    },
}
</script>

<style lang="scss" scoped>
.section__columns {
    --gap: 1.5rem;
    gap: var(--gap);
    margin-inline: auto;
    width: 100%;
    max-width: 1366px;
}

.section__text-column {
    font-size: 1.125rem;
    text-align: left;

    &::before {
        content: '';
        display: block;
        border-top: 1px solid var(--purple);
        margin-block: var(--gap);
        opacity: .75;
    }
}

@media (width > 767px) {
    .title {
        text-wrap: balance;
        padding-inline: 5%;
        margin-bottom: 2rem;
    }
    .section__columns {
        --gap: 2rem;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(31%, 1fr));
    }
    .section__text-column {
        font-size: 1.25rem;
        min-width: 0;
    }
}

</style>